import { MutableRefObject } from 'react'

import { DictationStartPauseButton } from '../../VisitDictationShared/Components/PlayPauseButton'
import { useTimeoverCheck } from '../../VisitDictationShared/hooks/useTimeoverCheck'
import { DictationMenu } from './DictationMenu'

interface Props {
    dictationContent: string
    dictationId: string
    audioRef: MutableRefObject<HTMLAudioElement | null>
}

export const ControllerBar = ({ audioRef, dictationContent, dictationId }: Props) => {
    useTimeoverCheck({ audioRef, visitId: dictationId })
    return (
        <div className="flex py-2 items-center justify-start w-full ">
            <DictationStartPauseButton />
            <DictationMenu dictationId={dictationId} dictationContent={dictationContent} />
        </div>
    )
}
